module.exports = __webpack_public_path__ + "img/pic28.f178662f.jpg";